import {
    Injectable,
    ApplicationRef,
    ComponentRef,
    Type,
    createComponent,
} from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ConfirmModalComponent } from '../modal/confirm-modal.component';
import { AlertModalComponent } from '../modal/alert-modal.component';

@Injectable({ providedIn: 'root' })
export class ModalService {
    constructor(private appRef: ApplicationRef) {}

    private async openModal<T>(
        component: Type<T>,
        inputs: Partial<T>
    ): Promise<any> {
        const componentRef: ComponentRef<T> = createComponent(component, {
            environmentInjector: this.appRef.injector,
        });

        Object.assign(componentRef.instance, inputs);

        this.appRef.attachView(componentRef.hostView);
        const domElem = (componentRef.hostView as any)
            .rootNodes[0] as HTMLElement;
        document.body.appendChild(domElem);

        try {
            return await firstValueFrom(
                (componentRef.instance as any).getResult()
            );
        } finally {
            this.appRef.detachView(componentRef.hostView);
            componentRef.destroy();
        }
    }

    confirm(message: string): Promise<boolean> {
        return this.openModal(ConfirmModalComponent, { message });
    }

    alert(
        message: string,
        type: 'success' | 'error' | 'warning' | 'info' = 'success'
    ): Promise<void> {
        return this.openModal(AlertModalComponent, { message, type });
    }
}
